import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "@/components/ui/command";

// Türkçe-duyarlı normalize: aksan/harf farkı olmadan aransın (ör. "istanbul"
// → "İstanbul", "cankaya" → "Çankaya"). Kullanıcı ASCII yazsa da eşleşir.
const trNorm = (s) =>
  (s || "")
    .toLocaleLowerCase("tr")
    .replace(/ı/g, "i").replace(/i̇/g, "i").replace(/ş/g, "s")
    .replace(/ğ/g, "g").replace(/ü/g, "u").replace(/ö/g, "o").replace(/ç/g, "c");

// Aranabilir açılır liste (combobox). options: string[] veya {value,label}[].
// Uzun listelerde (81 il, yüzlerce ilçe/mahalle) yazarak filtreleme sağlar.
export default function SearchableSelect({
  value,
  onChange,
  options = [],
  placeholder = "Seçin",
  searchPlaceholder = "Ara...",
  emptyText = "Sonuç bulunamadı",
  disabled = false,
  className,
  testId,
}) {
  const [open, setOpen] = useState(false);
  const items = options.map((o) => (typeof o === "string" ? { value: o, label: o } : o));
  const selected = items.find((i) => i.value === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild disabled={disabled}>
        <button
          type="button"
          role="combobox"
          aria-expanded={open}
          disabled={disabled}
          data-testid={testId}
          className={cn(
            "flex h-12 w-full items-center justify-between rounded-xl border border-slate-200 bg-white px-4 text-sm transition-colors hover:border-slate-300 disabled:opacity-60 disabled:cursor-not-allowed",
            !selected && "text-slate-400",
            className
          )}
        >
          <span className="truncate">{selected ? selected.label : placeholder}</span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="p-0 w-[var(--radix-popover-trigger-width)] min-w-[12rem]"
        align="start"
      >
        <Command filter={(val, search) => (trNorm(val).includes(trNorm(search)) ? 1 : 0)}>
          <CommandInput placeholder={searchPlaceholder} />
          <CommandList>
            <CommandEmpty>{emptyText}</CommandEmpty>
            <CommandGroup>
              {items.map((i) => (
                <CommandItem
                  key={i.value}
                  value={i.value}
                  onSelect={() => { onChange(i.value); setOpen(false); }}
                >
                  <Check className={cn("mr-2 h-4 w-4", value === i.value ? "opacity-100 text-[#10B981]" : "opacity-0")} />
                  {i.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
